import React from 'react'
import { HelpModal } from '../help/help-modal.component'

export const SimpleHelpModal = ({modalRef}) =>
  <HelpModal innerRef={modalRef} />